import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const missionMetricGradationTypesAdapter = createEntityAdapter({})

const initialState = missionMetricGradationTypesAdapter.getInitialState()

export const missionMetricGradationTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getMissionMetricGradationTypes: builder.query({
            query: () => ({
                url: '/missionMetricGradationTypes/getMissionMetricGradationTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedMissionMetricGradationTypes = responseData.map(missionMetricGradationType => {
                    missionMetricGradationType.id = missionMetricGradationType._id
                    return missionMetricGradationType
                })
                return missionMetricGradationTypesAdapter.setAll(initialState, loadedMissionMetricGradationTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'MissionMetricGradationType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'MissionMetricGradationType', id}))
                    ]
                } else {
                    return [ { type: 'MissionMetricGradationType', id: 'LIST'}]
                }
            },
        }),
        createNewMissionMetricGradationType: builder.mutation({
            query: initialMissionMetricGradationType => ({
                url: '/missionMetricGradationTypes/createNewMissionMetricGradationType',
                method: 'POST',
                body: {...initialMissionMetricGradationType,}
            }),
            invalidatesTags: [
                { type: 'MissionMetricGradationType', id: "LIST" }
            ] 
        }),
        updateMissionMetricGradationType: builder.mutation({
            query: initialMissionMetricGradationType => ({
                url: '/missionMetricGradationTypes/updateMissionMetricGradationType',
                method: 'PATCH',
                body: {...initialMissionMetricGradationType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'MissionMetricGradationType', id: arg.id },
                { type: 'MissionMetricGradationType', id: 'LIST' }
            ],
        }),
        deleteMissionMetricGradationType: builder.mutation({
            query: ({id}) => ({
                url: '/missionMetricGradationTypes/deleteMissionMetricGradationType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'MissionMetricGradationType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetMissionMetricGradationTypesQuery,
    useCreateNewMissionMetricGradationTypeMutation,
    useUpdateMissionMetricGradationTypeMutation,
    useDeleteMissionMetricGradationTypeMutation,
} = missionMetricGradationTypesApiSlice

// returns the query result object
export const selectMissionMetricGradationTypeResult = missionMetricGradationTypesApiSlice.endpoints.getMissionMetricGradationTypes.select()

// create memoized selector
const selectMissionMetricGradationTypesData = createSelector(
    selectMissionMetricGradationTypeResult,
    missionMetricGradationTypeResult => missionMetricGradationTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllMissionMetricGradationTypes,
    selectById: selectMissionMetricGradationTypeById,
    selectIds: selectMissionMetricGradationTypeIds,
} = missionMetricGradationTypesAdapter.getSelectors(state => selectMissionMetricGradationTypesData(state) ?? initialState)